/* tslint:disable:jsx-no-lambda WI:47602 */
import * as React from 'react';
import { InlineCalendar, ICalendarDayProps } from 'owa-datepicker';
import type { MonthViewSettings } from '..';

export function MiniCalendar(props: MonthViewSettings) {
    const { date, firstDayOfWeek, firstWeekOfYear, showWeekNumbers } = props;

    // custom styles to shift the header content and make room for showMoreOrLess button
    const calendarDayProps: Partial<ICalendarDayProps> = {
        styles: {
            header: {
                // Centralize the remaining header content.
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
            },
            dayCell: {
                // Override the background color of highlighted days.
                // Need both selectors as they both set the color, and need !important
                // because the color gets applied by the private class after the public class.
                backgroundColor: 'inherit !important',
            },
            daySelected: {
                backgroundColor: 'inherit !important',
            },
            monthComponents: {
                // Kill the container that shows the up/down buttons.
                display: 'none',
            },
            monthAndYear: {
                // Remove padding and marging from the header text, so it centralizes properly.
                marginLeft: 0,
                marginRight: 0,
                padding: 0,
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
            },
        },
    };

    return (
        <InlineCalendar
            value={date}
            calendarDayProps={calendarDayProps}
            onSelectDate={onSelectDate}
            firstDayOfWeek={firstDayOfWeek}
            firstWeekOfYear={firstWeekOfYear}
            showWeekNumbers={showWeekNumbers}
            showGoToToday={false}
            hideTodayEmphasis={true}
        />
    );
}

function onSelectDate() {
    // no-op
}
